import React, { FC } from 'react'

import { Cores, IconeInformacaoAzul, Tooltip } from 'src/componentes'

import { ContainerDoIcone } from './styles'

export interface TooltipInformacaoProps {
  id: string
  mensagem: string
  className?: string
}

/**
 * Ícone de informação com tooltip ao lado de um campo/rótulo — mesmo padrão de
 * TooltipParcelaObservacao (painel-financeiro), usado aqui para avisos que
 * antes ficavam soltos como texto na tela.
 */
export const TooltipInformacao: FC<TooltipInformacaoProps> = ({
  id,
  mensagem,
  className
}) => (
  <>
    <ContainerDoIcone className={className} data-tip={mensagem} data-for={id}>
      {IconeInformacaoAzul}
    </ContainerDoIcone>
    <Tooltip
      id={id}
      place="right"
      textColor={Cores.PRETO}
      backgroundColor={Cores.CINZA_1_CLARO}
      html
    />
  </>
)
